import { Injectable } from '@angular/core';
import { saveAs } from 'file-saver';
import { FileSaverOptions } from 'file-saver';

@Injectable({
  providedIn: 'root',
})
export class FileSaveService {
  constructor() {}

  saveFile(data: Blob | string, filename?: string, options?: FileSaverOptions) {
    saveAs(data, filename, options);
  }
}
